var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanejamentoEstrategico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.375 58.9187C83.9438 58.9187 79.5438 63.3187 79.5438 68.75C79.5438 74.1812 83.9438 78.5813 89.375 78.5813C94.8063 78.5813 99.2063 74.1812 99.2063 68.75C99.2063 63.3187 94.8063 58.9187 89.375 58.9187Z",
    fill: "#0F4C81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8188 20.625C64.4188 19.8688 42.6938 40.3563 41.3875 66.275L28.1875 83.875C26.4688 86.1437 28.1188 89.375 30.9375 89.375H41.25V110C41.25 117.562 47.4375 123.75 55 123.75H61.875V137.5C61.875 141.281 64.9688 144.375 68.75 144.375H103.125C106.906 144.375 110 141.281 110 137.5V112.2C126.775 104.225 138.188 86.9 137.5 66.9625C136.538 42.075 115.638 21.3813 90.8188 20.625ZM110 68.75C110 69.6438 109.931 70.5375 109.863 71.4313L115.569 75.9688C116.119 76.3813 116.256 77.0688 115.913 77.6875L110.413 87.2437C110.069 87.8625 109.313 88.0687 108.763 87.8625L101.956 85.1125C100.513 86.2125 99 87.1063 97.35 87.7938L96.25 95.0813C96.1813 95.7688 95.5625 96.25 94.875 96.25H83.875C83.1875 96.25 82.6375 95.7688 82.5 95.0813L81.4688 87.7938C79.75 87.1063 78.2375 86.2125 76.7938 85.1125L69.9875 87.8625C69.3688 88.0687 68.6125 87.8625 68.2688 87.2437L62.7688 77.6875C62.425 77.1375 62.5625 76.3813 63.1125 75.9688L68.8875 71.4313C68.8188 70.5375 68.75 69.6438 68.75 68.75C68.75 67.8563 68.8875 66.8938 69.025 66.0688L63.1813 61.5313C62.6313 61.1188 62.4938 60.4313 62.8375 59.7438L68.3375 50.2563C68.6813 49.6375 69.3688 49.4313 69.9875 49.6375L76.8625 52.3875C78.2375 51.3563 79.8188 50.3938 81.4688 49.7063L82.5 42.4188C82.6375 41.7313 83.1875 41.25 83.875 41.25H94.875C95.5625 41.25 96.1125 41.7313 96.25 42.4188L97.2813 49.7063C98.9313 50.3938 100.444 51.2875 101.888 52.3875L108.763 49.6375C109.381 49.4313 110.138 49.6375 110.413 50.2563L115.913 59.7438C116.256 60.3625 116.119 61.1188 115.569 61.5313L109.725 66.0688C109.931 66.8938 110 67.7875 110 68.75Z",
    fill: "#0F4C81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23_106",
    x: -4,
    y: -4,
    width: 173,
    height: 173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23_106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23_106",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanejamentoEstrategico);
export default __webpack_public_path__ + "static/media/PlanejamentoEstrategico.09cf7b8180adc54ce76ba3fb6f6b899e.svg";
export { ForwardRef as ReactComponent };